// Minimize the chatbot window on mobile if it
// Opens as soon as the chatbot finishes loading
export default function() {
  return function(chatbot) {
    chatbot.subscriptions.onDomReady(function (next) {
      if (window.innerWidth <= 768) {
        chatbot.actions.hideConversationWindow();
      }
      next();
    })
  }
}
